import { render, staticRenderFns } from "./HotelTime.vue?vue&type=template&id=34d25a79&"
import script from "./HotelTime.vue?vue&type=script&lang=js&"
export * from "./HotelTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports